import { skipToken, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useApi } from '#providers/api/index.ts';
import { getMessagesQueryKey } from '#providers/conversations/Conversations.helpers.ts';
import { getQueryLoadState } from '#providers/query/index.ts';
import type { TConversationMessages } from './useConversationMessages.types.ts';

export const useConversationMessages = (
  conversationId?: string,
): TConversationMessages => {
  const api = useApi();

  const queryKey = getMessagesQueryKey(conversationId);

  const query = useQuery({
    queryKey,
    queryFn: conversationId
      ? () =>
          api.conversations.getConversationMessages({
            conversation_id: conversationId,
          })
      : skipToken,
    staleTime: Infinity,
    gcTime: 0,
  });

  const messages = useMemo(() => query.data?.messages ?? [], [query.data]);

  const { isLoading, loadError } = getQueryLoadState(query);

  return {
    conversation: query.data?.conversation,
    messages,
    isLoadingMessages: isLoading,
    messagesError: loadError,
  };
};
